import { css, cx } from "@emotion/css";
import BackgroundIcon from "img/auth/background.svg";
import AuthLogoIcon from "img/auth/logo.svg";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import routing from "routing";
import ArticlesIcon from "src/images/Icons/newIcons/articles.svg";
import ArrowPrevIcon from "src/images/Icons/newIcons/controllers/arrowPrev.svg";
import BaseOfKnowledgeIcon from "src/images/Icons/newIcons/database.svg";
import FlashcardsIcon from "src/images/Icons/newIcons/flashcards.svg";

import { isLdek, isLek } from "../../../helpers/services";
import useQueryParams from "../../../hooks/useQueryParams";
import { TextPrimaryButton } from "../../Default/LekUI/Button";
import { FullHeightContainer } from "../Default/FullHeightContainer";

const InfoListItem = (props) => {
	return (
		<li className="info-details--container--detail">
			<div className="grey-square">{props.Icon}</div>
			<span className="size-24-light">{props.text}</span>
		</li>
	);
};

const InfoBox = () => {
	const { t } = useTranslation();

	return (
		<div className="info-container">
			<div className="info-container--background">
				<BackgroundIcon className="background-image" />
			</div>
			<div className="basic-box info-details--container">
				<AuthLogoIcon
					className={cx(css`
            width: 256px;
            height: 48px;
          `)}
				/>
				<h5 className="size-24-light">
					{t(isLdek() ? "auth.services.titleLDEK" : "auth.services.title")}
				</h5>
				<ul className="p-0 gap-24 flex flex-col items-start">
					<InfoListItem
						text={t(
							isLdek()
								? "auth.services.info.examsLdek"
								: "auth.services.info.exams",
						)}
						Icon={<BaseOfKnowledgeIcon className="icon-big" />}
					/>
					<InfoListItem
						text={t("auth.services.info.articles")}
						Icon={<ArticlesIcon className="icon-big" />}
					/>
					<InfoListItem
						text={t("auth.services.info.flashcards")}
						Icon={<FlashcardsIcon className="icon-big" />}
					/>
				</ul>
			</div>
		</div>
	);
};

const Header = (props) => {
	const history = useHistory();
	const { t } = useTranslation();
	const { pathname } = useLocation();

	const renderBackButton = () => {
		const shouldRender = [
			routing.paths.resetPassword,
			routing.paths.successResetPassword,
			routing.paths.setNewPassword,
			routing.paths.setPasswordError,
		].some((path) => path.startsWith(pathname));
		if (!isLek()) {
			return shouldRender;
		}

		return !routing.paths.signIn.startsWith(pathname) || shouldRender;
	};

	if (!renderBackButton()) {
		return null;
	}

	return (
		<div className={cx(props.className, "flex-center-row mt-8 ml-8")}>
			<TextPrimaryButton
				onClick={() => history.push(routing.paths.signIn)}
				className="p-0"
			>
				<ArrowPrevIcon className="icon-big icon-small" />
				<span className="ml-2 size-16">{t("auth.services.back")}</span>
			</TextPrimaryButton>
		</div>
	);
};

const Content = ({ children, title, Alert = null }) => {
	return (
		<div className="auth-container">
			<Header className="p-absolute top-0 left-0" />
			<AuthLogoIcon className="auth-container--logo" />
			<div className="auth-container--form">
				{Alert}
				<h3 className="size-32 m-0">{title}</h3>
				{children}
			</div>
		</div>
	);
};

let redirectUrl = null;
function DefaultAuth({ Form, title, Alert }) {
	const queryParams = useQueryParams();
	const url = queryParams.get("redirectUrl");
	redirectUrl = url ? url : redirectUrl;

	return (
		<FullHeightContainer className="auth">
			<InfoBox />
			<Content title={title} Alert={Alert}>
				<Form redirectUrl={redirectUrl} />
			</Content>
		</FullHeightContainer>
	);
}

export default DefaultAuth;
